export default {
  // 音波表示
  showWave: true,
  // 音速 [m/s]
  speed: 340,
  // 最大振動数 [Hz]
  maxFreq: 1000,
  // 最小振動数 [Hz]
  minFreq: 0,
  // 最大振幅
  maxAmp: 300,
  // 最大距離 [cm]
  maxDist: 500,
  // ワイングラスの固有振動数 [Hz]
  naturalFreq: 650,
  // 振幅閾値
  thresholdAmp: 60,
  // 初期振動数 [Hz]
  freq: 300,
  // 初期振幅
  amp: 80,
  // 初期距離 [cm]
  dist: 500,
  // 振幅半減距離 [cm]
  halfAmplitudeDistance: 500,
};